export const apiService = {
  // Websockets
  ws: {
    baseUrl: process.env.REACT_APP_API_BASE_URL + "/ws",
    chatTopicUrl: (phoneNumber) => `/chat/${phoneNumber}/messages`,
    sendMessageEndpoint: "/app/chat.sendMessage",
  },

  websiteChatBox: {
    receivingSms: () =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/receivingSms`,
    getOfficeDetails: (officeName) =>
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/officeDetails/${officeName}`,
    getMessages: (phone, startCount, endCount) =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/messages/${phone}?startCount=${startCount}&endCount=${endCount}`,
    getConversation: (phone, agentIdFromCookie) =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/conversation/${phone}/${agentIdFromCookie}`,
    checkAgentAvailability: (officeName, phone) =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/available-agents/office/${officeName}`,
    uploadFile: () => `${process.env.REACT_APP_API_BASE_URL}/api/sms/upload`,
    saveCustomerInfo: () =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/customer-data`,
    checkSessionStatus: (sessionId) =>
      `${process.env.REACT_APP_API_BASE_URL}/api/sms/chat/session-status/${sessionId}`,
  },
};
